import { TranslateService } from '@ngx-translate/core';
import { DataSheetFilterEntry, activeRowCount, countSelectedRows } from './data-sheet-filters.codec';

/**
 * Zeilen-Label einer Testdatenblatt-Auswahl: „3 von 8 Zeilen", bei
 * Variablen-Bedingungen mit `≤`-Praefix, ohne Filter die reine Gesamtzahl.
 *
 * <p>NEX-1052-Review (sgraetz): Vorher stand diese Rechnung samt hart
 * einkodierter deutscher Texte mehrfach im TypeScript (Drawer, Step-Tabelle) —
 * derselbe Zustand las sich je Stelle anders und blieb auf Englisch deutsch.
 *
 * <p>Gezaehlt wird ueber {@link countSelectedRows}, deckungsgleich mit Server und
 * Engine: Ueberschneidungen zaehlen einmal, Nummern jenseits des Blatts gar nicht,
 * ausgeschaltete Zeilen ({@code active}, NEX-2262) weder in der Auswahl noch in der Gesamtzahl.
 */
export function tdbRowSelectionLabel(
  translate: TranslateService,
  total: number,
  filter: string,
  saved?: readonly DataSheetFilterEntry[] | null,
  active?: readonly boolean[] | null,
): string {
  const selection = filter.trim();
  const activeTotal = activeRowCount(total, active);
  if (!selection) {
    return translate.instant('tdb.status.totalRows', { total: activeTotal });
  }
  const { count, bounded } = countSelectedRows(total, selection, saved, active);
  return bounded
    ? translate.instant('tdb.status.rowsUpTo', { count, total: activeTotal })
    : translate.instant('tdb.status.rowsExact', { count, total: activeTotal });
}
